import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getProductFoodShotsCancelToken,
  getProductFoodShots,
  resetProductFoodShots,
} from '../../actions/products';
import { getProductSingleReview } from '../../actions/products/reviews';

const FoodShotListItem = ({ foodShot, handleFoodShowClick }) => {
  if (!foodShot.meta) return null;
  const imageSource = foodShot.meta.original_photo;
  return (
    <li onClick={() => handleFoodShowClick(foodShot.id)} className="product__food-shot__list__item">
      <img src={imageSource} alt={`food shot`} className="product__food-shot__list__item__image" />
    </li>
  );
};

// food shot list item
const FoodShotList = ({ foodShots, handleFoodShowClick }) => {
  let listBox = (
      <li key={`feed-shot-start`} className="product__food-shot__list__item__box">
        <p>FOOD SHOTS</p>
      </li>
    ),
    listItems = foodShots.map((foodShot) => (
      <FoodShotListItem
        handleFoodShowClick={handleFoodShowClick}
        foodShot={foodShot}
        key={`food-shot-${foodShot.id}`}
      />
    )),
    listItemsToShow = [listBox, ...listItems];
  return <ul className="product__food-shot__list">{listItemsToShow}</ul>;
};

const ProductFoodShots = (props) => {
  const { token, isPublic, publicClickAction, getProductFoodShots, getProductSingleReview } = props;
  const [productId] = useState(props.productId);
  const [foodShots, setFoodShots] = useState(props.foodShots);

  // function to set product review
  function handleFoodShowClick(reviewId) {
    if (isPublic) {
      publicClickAction();
      return;
    }
    getProductSingleReview(token, productId, reviewId);
  }
  // fetching food shots
  useEffect(() => {
    getProductFoodShots(token, productId, isPublic);
    return function cleanup() {
      if (getProductFoodShotsCancelToken) getProductFoodShotsCancelToken();
      props.resetProductFoodShots();
    };
  }, []);
  useEffect(() => {
    setFoodShots(props.foodShots);
  }, [props.foodShots]);
  if (foodShots.fetching && foodShots.page === 1) return null;
  if (foodShots.hasFetched && !foodShots.all.length) return null;
  return (
    <div className="product__food-shot__container">
      <FoodShotList handleFoodShowClick={handleFoodShowClick} foodShots={foodShots.all} />
    </div>
  );
};

FoodShotListItem.propTypes = {
  foodShot: PropTypes.object,
  handleFoodShowClick: PropTypes.func,
};

FoodShotList.propTypes = {
  foodShots: PropTypes.array,
  handleFoodShowClick: PropTypes.func,
};
ProductFoodShots.propTypes = {
  foodShots: PropTypes.array,
  token: PropTypes.string,
  productId: PropTypes.string.isRequired,
  isPublic: PropTypes.bool,
  publicClickAction: PropTypes.func,
  getProductFoodShots: PropTypes.func,
  getProductSingleReview: PropTypes.func,
  resetProductFoodShots: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    token: state.login.token,
    foodShots: state.productReducer.foodShots,
  };
}

const mapDispatchToProps = {
  getProductFoodShots,
  getProductSingleReview,
  resetProductFoodShots,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductFoodShots);
